export enum Entitlements {
    /**
     * Products
     */
    AddProductFeature = 'Add Product Feature',
    EditProductFeature = 'Edit Product Feature',
    /**
     * Transfers
     */
    CreateTransfer = 'Transfer, Create',
    EditTransfer = 'Edit Transfer',
    DeleteTransfer = 'Delete Transfer',
    ApproveTransfer = 'Approve Transfer',
    CreateTransferTemplate = 'Create Template',
    /**
     * RDC
     */
    RemoteDeposits = 'Remote Deposits',
    /**
     * ACH
     */
    RestrictAchBatch = 'Restricted Batch',
    CreateAchTemplate = 'Create Ach Template',
    FullEditAchTemplate = 'Full Edit Ach Template',
    PartialEditAchTemplate = 'Partial Edit Ach Template',
    DeleteAchTemplate = 'Delete Ach Template',
    ApproveAchTemplate = 'Approve Ach Template',
    CreateAchPayment = 'ACH, Batch, CreatePayment',
    FullEditAchPayment = 'ACH, Payment, Full Edit',
    PartialEditAchPayment = 'ACH, Payment, Partial Edit',
    DeleteAchPayment = 'Delete Ach Payment',
    ApproveAchPayment = 'Approve Ach Payment',
    CreateRecipient = 'Create Recipient',
    EditRecipient = 'Edit Recipient',
    DeleteRecipient = 'Delete Recipient',
    ApproveRecipient = 'Approve Recipient',
    CreateInternationalAchTemplate = 'Create International Ach Template',
    FullEditInternationalAchTemplate = 'Full Edit International Ach Template',
    PartialEditInternationalAchTemplate = 'Partial Edit International Ach Template',
    DeleteInternationalAchTemplate = 'Delete International Ach Template',
    ApproveInternationalAchTemplate = 'Approve International Ach Template',
    CreateInternationalAchPayment = 'Create International ACH Payment',
    FullEditInternationalAchPayment = 'Full Edit International ACH Payment',
    PartialEditInternationalAchPayment = 'Partial Edit International ACH Payment',
    DeleteInternationalAchPayment = 'Delete International ACH Payment',
    ApproveInternationalAchPayment = 'Approve International ACH Payment',
    FileUploadEdit = 'File Upload Edit',
    FileUploadEditInternationalAchPayment = 'File Upload Edit International ACH Payment',
    AllowUnbalancedPayments = 'Feature.ACH.AllowUnbalancedPayments',
    AllowUnbalancedReversals = 'Feature.Ach.AllowUnbalancedBatches.Reversals',
    /**
     * ACH Exceptions
     */
    WorkAchExceptions = 'Work ACH Exceptions',
    CreateAchFilter = 'Create ACH Filter',
    /**
     * Check Exceptions
     */
    WorkCheckExceptions = 'Work Check Exceptions',
    AllowReturnReason = 'Feature.PositivePay.CheckException.ReturnReason.Default.TM1742',
    HasReturnReason = 'Feature.PositivePay.ReturnReason',
    /**
     * Issued Items
     */
    EditIssuedItems = 'Edit Issued Items',
    /**
     * Wires
     */
    CreateDomesticWire = 'Wire, Domestic, Create Wire',
    CreateInternationalWire = 'Wire, International, Create Wire',
    CreateFxWire = 'Wire Transfer DLI, Create Wire',
    CreateDomesticCreditor = 'Wire, Domestic, Create Beneficiary',
    CreateInternationalCreditor = 'Wire, International, Create Beneficiary',
    CreateFxCreditor = 'Wire, Fx, Create Beneficiary',
    CreateWireTemplate = 'Wire, Domestic, Create Wire Template',
    WireEditBeneficiary = 'Edit Beneficiary',
    WireApproveBeneficiary = 'Approve Beneficiary',
    CancelWire = 'Cancel Wire',
    EditDomesticWirePayment = 'Edit Domestic Wire Payment',
    DeleteDomesticWirePayment = 'Delete Domestic Wire Payment',
    ApproveDomesticWirePayment = 'Approve Domestic Wire Payment',
    EditInternationalWirePayment = 'Edit International Wire Payment',
    DeleteInternationalWirePayment = 'Delete International Wire Payment',
    ApproveInternationalWirePayment = 'Approve International Wire Payment',
    ApproveFxWirePayment = 'Approve DLI Wire Payment',
    RejectWire = 'Reject Wire',
    WireUpload = 'Upload Domestic Wire File',
    ManageWireFileFormats = 'Manage Wire File Format',
    /**
     * Stop Payments
     */
    AddStopPayment = 'Add Stop Payment',
    ApproveStopPayment = 'Approve Stop Payment',
    CancelStopPayment = 'Cancel Stop Payment',
    /**
     * Bill Pay
     */
    BusinessBillPay = 'Bill Pay',
    /**
     * High-Level Feature Checks
     */
    achEnabled = 'ACH Enabled',
    transfersEnabled = 'Transfers Enabled',
    wiresEnabled = 'Wires Enabled',
    billPayEnabled = 'Bill Pay Enabled',
    remoteDepositsEnabled = 'Remote Deposits Enabled',
    /**
     * Backoffice — Reports
     */
    ManageReports = 'Manage Reports',
    /**
     * Backoffice — Company Entitlements
     */
    ExecuteCompanySearch = 'Execute Company Search',
    AccessCompanyProfile = 'Access Company Profile',
    OnboardCompany = 'Onboard Company',
    EditMfa = 'Edit Multi-Factor Authentication',
    EditMfaSettings = 'Edit Multi-Factor Authentication Settings',
    ManageBillingOptions = 'Manage Billing Options',
    AddAccounts = 'Add Accounts',
    EditAccount = 'Edit Account',
    AddCompanyUser = 'Add User',
    EditCompanyUser = 'Edit User',
    SwitchFi = 'Switch FI',
    ResetUserPassword = 'Reset User Password',
    /**
     * Customer Engagement
     */
    EditInformationCenterConfiguration = 'Edit Information Center Configuration',
    ViewInformationCenterConfiguration = 'View Information Center Configuration',
    InformationCenterAddMessage = 'Information Center Configuration Add Message',
    EditResourcesPanelConfiguration = 'Edit Resources Panel Configuration',
    ViewResourcePanelConfiguration = 'View Resource Panel Configuration',
    ResourcesPanelAddLink = 'Resources Panel Configuration Add Link',
    /**
     * LD FFs
     */
    InformationCenterModalBannerEnhancement = 'Feature.MessageCenterEnhancement',
    /**
     * FI Users
     */
    AddFiUser = 'Add FI User',
    ViewFiUser = 'View FI User',
    EditFiUser = 'Edit FI User',
    ResetFiPassword = 'Reset FI Password',
    DeleteFiUser = 'Delete FI User',
    ChangeFiUserStatus = 'Change FI User Status',
    ChangeFiUserLockedStatus = 'Change FI User Locked Status',
    /**
     * FI User Roles
     */
    AddUserRole = 'Add User Role',
    EditUserRole = 'Edit User Role',
    ViewUserRole = 'View User Role',
    /**
     * Authentication Profiles
     */
    AddChallengePointProfile = 'Add Challenge Point Profile',
    EditChallengePointProfile = 'Edit Challenge Point Profile',
    ViewChallengePointProfile = 'View Challenge Point Profile',
    EnsOobValidatePerFi = 'Feature.Authentication.EnsOobValidatePerFi',
    /**
     * Content Management
     */
    EditContentManagement = 'Edit Content Management',
    ViewContentManagementConfiguration = 'View Content Management Configuration',
    /**
     * Notification Configuration
     */
    EditNotificationConfiguration = 'Edit Notification Configuration',
    ViewNotificationConfiguration = 'View Notification Configuration',
    /**
     * Message Center Configuration
     */
    ManageMessageCenterConfiguration = 'Manage Message Center Configuration',
    ViewMessageCenterConfiguration = 'View Message Center Configuration',
    /**
     * FI User Settings
     */
    ManageFiUserSettings = 'Manage FI User Settings',
    ViewFiUserSettings = 'View FI User Settings',
    /**
     * Company User Settings
     */
    ManageCompanyUserSettings = 'Manage Company User Settings',
    ViewCompanyUserSettings = 'View Company User Settings',
    /**
     * Terms and Conditions
     */
    ManageTermsAndConditions = 'Manage Terms and Conditions',
    ViewTermsAndConditions = 'View Terms and Conditions',
    /**
     * Transaction Code Configuration
     */
    ManageTransactionCodeConfiguration = 'Manage Transaction Code Configuration',
    ViewTransactionCodeConfiguration = 'View Transaction Code Configuration',
    /**
     * Processing Configuration
     */
    ProcessingConfigurationEditCutoff = 'Processing Configuration Edit Cutoff',
    ProcessingConfigurationHolidayExceptionsAdd = 'Processing Configuration Holiday Exceptions Add',
    ProcessingConfigurationHolidayExceptionsEdit = 'Processing Configuration Holiday Exceptions Edit',
    ProcessingConfigurationHolidayExceptionsDelete = 'Processing Configuration Holiday Exceptions Delete',
    ViewProcessingConfiguration = 'View Processing Configuration',
    /**
     * Product Feature Configuration
     */
    EditProductFeatureConfiguration = 'Edit Product Feature Configuration',
    ViewProductFeatureConfiguration = 'View Product Feature Configuration',
}
